<dx-data-grid
  id="tasks-grid"
  height="100%"
  [dataSource]="tasks"
  (onRowPrepared)="onRowPreparedGrid($event)"
  (onRowClick)="test($event)"
  (onEditingStart)="toogleUseNavigation()"
  (onEditCanceled)="toogleUseNavigation()"
  (onSaved)="toogleUseNavigation()"
  [hoverStateEnabled]="true"
  [columnAutoWidth]="true"
>
  <dxo-paging [pageSize]="15"></dxo-paging>
  <dxo-pager [visible]="true" [showPageSizeSelector]="true"></dxo-pager>
  <dxo-editing mode="row" [allowUpdating]="true"> </dxo-editing>
  <dxo-selection
    selectAllMode="allPages"
    showCheckBoxesMode="always"
    mode="multiple"
  ></dxo-selection>
  <dxo-scrolling mode="virtual"></dxo-scrolling>
  <dxo-sorting mode="multiple"></dxo-sorting>
  <dxo-header-filter [visible]="true"></dxo-header-filter>

  <dxi-column dataField="text" caption="Konu" [hidingPriority]="7">
    <dxi-validation-rule type="required"></dxi-validation-rule>
  </dxi-column>
  <dxi-column dataField="company" caption="Firma" [hidingPriority]="6">
    <dxi-validation-rule type="required"></dxi-validation-rule>
  </dxi-column>
  <dxi-column
    dataField="priority"
    caption="Öncelik"
    [hidingPriority]="4"
    cellTemplate="cellPriority"
    editCellTemplate="editCellPriority"
  >
    <dxo-lookup [dataSource]="priorityList"></dxo-lookup>
    <dxi-validation-rule type="required"></dxi-validation-rule>
  </dxi-column>
  <dxi-column
    dataField="startDate"
    caption="Başlangıç T."
    dataType="date"
    [hidingPriority]="2"
  >
    <dxi-validation-rule type="required"></dxi-validation-rule>
  </dxi-column>
  <dxi-column
    dataField="dueDate"
    caption="Bitiş T."
    dataType="date"
    sortOrder="asc"
    [hidingPriority]="1"
  >
    <dxi-validation-rule type="required"></dxi-validation-rule>
  </dxi-column>
  <dxi-column dataField="owner" caption="Sahibi" [hidingPriority]="5">
    <dxi-validation-rule type="required"></dxi-validation-rule>
  </dxi-column>
  <dxi-column
    dataField="status"
    caption="Durum"
    [hidingPriority]="3"
    [minWidth]="120"
    cellTemplate="cellStatus"
    editCellTemplate="editCellStatus"
  >
    <dxo-lookup [dataSource]="statusList"></dxo-lookup>
    <dxi-validation-rule type="required"></dxi-validation-rule>
  </dxi-column>

  <div *dxTemplate="let cellInfo of 'cellPriority'">
    <dk-status-indicator
      [isField]="false"
      [showBar]="true"
      [value]="cellInfo.data.priority"
    >
    </dk-status-indicator>
  </div>

  <div *dxTemplate="let cellInfo of 'editCellPriority'">
    <dx-select-box
      class="edit-cell"
      [(value)]="cellInfo.value"
      [items]="priorityList"
      (onValueChanged)="cellInfo.setValue($event.value)"
      (onSelectionChanged)="cellInfo.component.updateDimensions()"
      fieldTemplate="field"
    >
      <div *dxTemplate="let data of 'field'">
        <dk-status-indicator
          [showBar]="true"
          [value]="cellInfo.value"
        ></dk-status-indicator>
      </div>
      <div *dxTemplate="let data of 'item'">
        <dk-status-indicator
          [showBar]="true"
          [isField]="false"
          [value]="data"
        ></dk-status-indicator>
      </div>
    </dx-select-box>
  </div>

  <div *dxTemplate="let cellInfo of 'cellStatus'">
    <dk-status-indicator
      [isField]="false"
      [value]="cellInfo.data.status"
    ></dk-status-indicator>
  </div>

  <div *dxTemplate="let cellInfo of 'editCellStatus'">
    <dx-select-box
      class="edit-cell"
      [(value)]="cellInfo.value"
      [items]="statusList"
      (onValueChanged)="cellInfo.setValue($event.value)"
      (onSelectionChanged)="cellInfo.component.updateDimensions()"
      fieldTemplate="field"
    >
      <div *dxTemplate="let data of 'field'">
        <dk-status-indicator [value]="cellInfo.value"></dk-status-indicator>
      </div>
      <div *dxTemplate="let s of 'item'">
        <dk-status-indicator
          [isField]="false"
          [value]="s"
        ></dk-status-indicator>
      </div>
    </dx-select-box>
  </div>
</dx-data-grid>

<ng-container *ngIf="showTaskDetail === true">
  <dx-popover
    target="#belloutline"
    showEvent="click"
    position="top"
    [visible]="showTaskDetail"
  >
    <dx-scroll-view width="100%" class="popover-scroll">
      <dk-planning-task-details
        (closePopup)="closedPopover($event)"
      ></dk-planning-task-details>
    </dx-scroll-view>
  </dx-popover>
</ng-container>

<!-- dk-planning-task-details -->
